import type { ActionItemDraftReviewProjectionAdapter, NotesBlockReviewLocator } from './types.ts';

function notesBlockReviewLocator(noteId: string, blockId: string): NotesBlockReviewLocator {
  return { adapterId: 'notesBlock', noteId, blockId };
}

export const notesBlockReviewProjectionAdapter: ActionItemDraftReviewProjectionAdapter = {
  adapterId: 'notesBlock',
  project(draft) {
    const block = draft.evidenceBlock;
    if (
      block.isActionItem !== true
      || block.sourceType !== 'notesBlock'
      || block.entityType !== 'note'
      || typeof block.entityId !== 'string'
      || typeof block.blockId !== 'string'
    ) {
      return null;
    }

    return {
      locator: notesBlockReviewLocator(block.entityId, block.blockId),
      evidenceKey: block.evidenceKey,
    };
  },
};
